<template>
  <div class="dialog-wrap">
    <el-dialog title="院校简介"
               :close-on-click-modal="false"
               :visible.sync="dialogVisible"
               @close="handleClose"
               @open="open"
               width="900px">

      <div>
        <el-descriptions direction="horizontal"
                         :column="1"
                         border
                         :labelStyle="mylabel"
                         title="">

          <el-descriptions-item label="校园风光">
            <div class="border"> <el-upload :action="imgUploadUrl"
                         list-type="picture-card"
                         :file-list="fileList"
                         :on-preview="handlePictureCardPreview"
                         :on-success="handleImgSuccess"
                         :on-remove="handleRemove">
                <i class="el-icon-plus"></i>
              </el-upload>
              <el-dialog :visible.sync="ImgVisible">
                <img width="100%"
                     :src="dialogImageUrl"
                     alt="">
              </el-dialog>
            </div>
            <div class="desc">请上传JPEG、JPG、PNG格式图片，最多20张</div>

          </el-descriptions-item>
          <el-descriptions-item label="视频简介">
            <el-upload class="uploader"
                       accept=""
                       :action="fileUploadPrivateUrl"
                       :headers="uploadHeaders"
                       :file-list="videoList"
                       :on-success="handleUploadSuccess"
                       :on-remove="handleUploadRemove">
              <el-button size="small"
                         type="primary"
                         icon="el-icon-upload2"
                         plain>点击上传</el-button>
              <span style="margin-left: 10px">只能上传一个视频</span>
            </el-upload>

            <!-- 视频预览 -->
            <div v-if="videoUrl"
                 class="video-preview">
              <video :src="videoUrl"
                     width="300px"
                     height="300px"
                     controls></video>
            </div>
          </el-descriptions-item>
          <el-descriptions-item label="联系电话">
            <el-input v-model="contact_phone"></el-input>
          </el-descriptions-item>

          <el-descriptions-item label=" 联系邮箱">
            <el-input v-model="contact_email"></el-input>
          </el-descriptions-item>

          <el-descriptions-item label="研招办网址">
            <el-input v-model="contact_enrol_website"></el-input>
          </el-descriptions-item>

          <el-descriptions-item label="联系地址">
            <el-input v-model="contact_address"></el-input>
          </el-descriptions-item>

          <el-descriptions-item label="邮编">
            <el-input v-model="zip_code"></el-input>
          </el-descriptions-item>

          <el-descriptions-item label="最新更新人">{{last_update_admin_nickname !='' ?last_update_admin_nickname:'' }}</el-descriptions-item>
          <el-descriptions-item label="更新时间">{{update_time !=null ?  $moment(update_time).format('YYYY-MM-DD hh:mm') :'' }}</el-descriptions-item>

        </el-descriptions>
      </div>
      <VueEditor :content="introduct_content"
                 placeholder="院校简介"
                 @change="handleDetailChange" />
      <div style="display:flex; justify-content: flex-end;marginTop:30px">
        <div>
          <el-button @click="handleClose">取 消</el-button>
          <el-button type="primary"
                     @click="handleSubmit">确 定</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import VueEditor from '@/components/VueEditor'

import {
  imgUploadUrl,
  uploadHeaders,
  fileUploadPrivateUrl,
  fileUploadUrl,
  resourceCreate,
} from '@/config/index'
import {
  collegeIntroductCreated,
  collegeIntroductDetail,
  collegeIntroductPut,
} from '@/api/admission'
export default {
  components: {
    VueEditor,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    college_code: {
      type: Number,
      default: () => {
        return null
      },
    },
    IntroductId: {
      type: Number,
      default: () => {
        return null
      },
    },
  },
  watch: {
    visible(val) {
      this.dialogVisible = val
    },
  },
  data() {
    return {
      imgUploadUrl: imgUploadUrl(),
      uploadHeaders: uploadHeaders(),
      fileUploadPrivateUrl: fileUploadUrl(),
      videoList: [],
      dialogVisible: this.visible,
      fileList: [],
      resource: {},
      dialogImageUrl: '',
      ImgVisible: false,
      videoUrl: '',
      mylabel: {
        width: '120px',
      },
      introduct_content: '',
      update_time: null,
      last_update_admin_nickname: '',
      collegeContent: null,
      contact_phone: '',
      contact_email: '',

      contact_enrol_website: '',

      contact_address: '',

      zip_code: '',
    }
  },

  methods: {
    open() {
      this.CollageDetail()
    },
    // 院校简介详情
    CollageDetail() {
      collegeIntroductDetail({
        college_code: this.college_code,
      }).then((res) => {
        this.collegeContent = res
        if (res) {
          if (res.introduct) {
            this.introduct_content = res.introduct
          }
          if (res.introduct_img_urls) {
            res.introduct_img_urls.split(',').map((item) => {
              this.fileList.push({
                url: item,
              })
            })
          }
          if (res.introduct_video_urls) {
            this.videoUrl = res.introduct_video_urls
            this.videoList.push({
              url: res.introduct_video_urls,
            })
          }

          this.contact_phone = res.contact_phone
          this.contact_email = res.contact_email
          this.contact_enrol_website = res.contact_enrol_website
          this.contact_address = res.contact_address
          this.zip_code = res.zip_code

          this.update_time = res.update_time
          this.last_update_admin_nickname = res.last_update_admin_nickname
        }
      })
    },
    handleDetailChange(editor) {
      this.introduct_content = editor.html
      console.log(this.dataForm.detail)
    },
    handleRemove(file, fileList) {
      this.fileList = fileList
      console.log('this.filelist', this.fileList)
    },
    handleImgSuccess(response, file, fileListt) {
      this.fileList.push({
        url: response.data.url,
      })
      console.log('this.fileList', this.fileList)
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url
      console.log(' this.dialogImageUrl ', this.dialogImageUrl)
      this.ImgVisible = true
    },
    handleUploadSuccess(res, file) {
      this.videoUrl = res.data.url
    },
    handleUploadRemove() {
      this.fileList = []
    },
    handleClose() {
      this.$emit('close')
      this.fileList = []
      this.videoList = []
      this.videoUrl = ''
      this.last_update_admin_nickname = ''
      this.update_time = null
      this.introduct_content = ''
      this.collegeContent = null
    },
    handleSubmit() {
      let imgUrl = []
      this.fileList.map((item) => {
        imgUrl.push(item.url)
      })
      if (this.collegeContent == null) {
        console.log('1')
        let data = {
          introduct: this.introduct_content,
          zip_code: this.zip_code,

          contact_phone: this.contact_phone,

          contact_email: this.contact_email,

          contact_enrol_website: this.contact_enrol_website,

          contact_address: this.contact_address,

          introduct_img_urls: imgUrl.join(','),
          introduct_video_urls: this.videoUrl,
        }
        collegeIntroductCreated(data).then((res) => {
          this.handleClose()
          this.$message.success('创建成功')
        })
      } else {
        console.log('2')

        let data = {
          college_code: this.college_code,
          introduct: this.introduct_content,
          introduct_img_urls: imgUrl.join(','),
          introduct_video_urls: this.videoUrl,
          zip_code: this.zip_code,

          contact_phone: this.contact_phone,

          contact_email: this.contact_email,

          contact_enrol_website: this.contact_enrol_website,

          contact_address: this.contact_address,
        }
        collegeIntroductPut(data).then((res) => {
          this.handleClose()
          this.$message.success('修改成功')
        })
      }
    },
  },
}
</script>

<style lang="less" scoped>
::v-deep .el-dialog__header {
  background: #ebeef5;
}
.cover-uploader /deep/ .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  width: 112px;
  height: 112px;
}

.cover-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  max-width: 100%;
  max-height: 200px;
  line-height: 100px;
  text-align: center;
}
.cover {
  display: block;
  max-width: 100%;
  max-height: 200px;
  object-fit: cover;
  margin: 0 auto;
}
.border {
  padding: 10px;
  width: 100%;
  border: 1px dashed #d9d9d9;
}
.desc {
  margin-top: 10px;
  font-weight: normal;
  font-size: 12px;
  color: #cccccc;
}
</style>
